/**
 * Copyright 2024 Phenix Real Time Solutions, Inc. Confidential and Proprietary. All Rights Reserved.
 */
import PhenixWebSocket from './websocket.provider';

class WebsocketConnection {
  activeSocket = null;
  rolledSockets = new Set<PhenixWebSocket>();

  constructor() {
    this.init();
  }

  init() {
    this.activeSocket = {
      isConnected: () => false,
      isAuthenticated: () => false
    } as PhenixWebSocket;
  }

  setActiveSocket(socket: PhenixWebSocket): void {
    if (this.activeSocket.uniqueId && this.activeSocket.uniqueId !== socket.uniqueId) {
      this.rolledSockets.add(this.activeSocket);
    }

    this.activeSocket = socket;
  }

  getActiveSocket(): PhenixWebSocket {
    return this.activeSocket;
  }

  getRolledSockets(): Set<PhenixWebSocket> {
    return this.rolledSockets;
  }

  clear(): void {
    this.init();
    this.rolledSockets.clear();
  }
}

export default new WebsocketConnection();